<template>
  <form class="mt-6 grid grid-cols-1 row-gap-6 sm:grid-cols-2 sm:col-gap-8">
    <contact-form-errors :errors="errors" :is-dark="true"/>
    <contact-form-first-name
        :is-active="activeInput"
        :value="params.name"
        @input="params.name = $event"
        @active="activeInput = $event"/>
    <contact-form-email
        :is-active="activeInput"
        :value="params.email"
        @input="params.email = $event"
        @active="activeInput = $event"
    />
    <contact-form-phone
        :is-active="activeInput"
        :value="params.phone"
        @input="params.phone = $event"
        @active="activeInput = $event"
    />
    <contact-form-message
        :is-active="activeInput"
        :value="params.message"
        @input="params.message = $event"
        @active="activeInput = $event"/>
    <contact-form-submit @onContactSubmit="onContactSubmit" :loading="loading"/>
  </form>
</template>

<script>

import ContactFormErrors from "@/components/utils/contact-form/ContactFormErrors";
import ContactFormFirstName from "@/components/utils/contact-form/ContactFormFirstName";
import ContactFormEmail from "@/components/utils/contact-form/ContactFormEmail";
import ContactFormPhone from "@/components/utils/contact-form/ContactFormPhone";
import ContactFormMessage from "@/components/utils/contact-form/ContactFormMessage";
import ContactFormSubmit from "@/components/utils/contact-form/ContactFormSubmit";
import contactForm from "@/mixins/contactForm";
import db from "@/firebaseConfig";

export default {
  name: "CalculatorContactForm",
  mixins: [contactForm],
  components: {
    ContactFormErrors,
    ContactFormFirstName,
    ContactFormEmail,
    ContactFormPhone,
    ContactFormMessage,
    ContactFormSubmit
  },
  methods: {
    insertMessage() {
      this.loading = true
      const offerDetails = {
        totalAmount: this.$store.getters['prices/GET_TOTAL_AMOUNT'],
        depositPercentage: this.$store.getters['prices/GET_DEPOSIT_PERCENTAGE'],
        depositAmount: this.$store.getters['prices/GET_DEPOSIT_AMOUNT'],
        period: this.$store.getters['prices/GET_PERIOD'],
        monthlyPayment: this.$store.getters['prices/GET_MONTHLY_PAYMENT'],
        multiplier: this.$store.getters['prices/GET_MULTIPLIER'],
        features: this.$store.getters['prices/GET_FEATURES'],
        params: this.params,
        time: new Date()
      }
      db.collection("offers")
          .add(offerDetails)
          .then(() => {
            this.loading = false
            this.$emit('messageSent')
            this.resetComponentState()
          })
          .catch((error) => {
            // TODO: ney :(
            this.loading = false
            console.error("Error writing document: ", error);
          });
    }
  }
}
</script>

<style scoped>

</style>
